export default __webpack_public_path__ + "static/media/backgroundPrimary.ee4b5d50.png";